<h1>{{ 'transfers.title' | translate }}</h1>

<form id="search-form" [formGroup]="searchForm">
    <div class="input-group">
        <div class="left-icon"><img [src]="utils.imageUrl('ecl-search-blue.png')"></div>
        <input name="searched_value" formControlName="searched_value" autocomplete="off">
        <div class="right-icon"><img [src]="utils.imageUrl('ecl-teams-blue.png')"></div>
    </div>
</form>

@if(Object.keys(transfersByDay()).length > 0) {
  <div id="transfers">
  <div [nbSpinner]="loading()"
       nbSpinnerStatus="danger"
       nbSpinnerSize="large"
       nbSpinnerMessage="">
      @for (day of (transfersByDay() | keyvalue: preserveOrder); track day.key) {
        <div class="day">{{ formatDay(day.key) }}</div>
        <table>
            <tbody>
                @for (transfer of getTransfers(day.value) | keyvalue; track transfer.key) {
                    <tr>
                        <td class="transfer-icon"><img [src]="utils.imageUrl(transfer.value.action_type == 'add' ? 'ecl-transfer-add.png' : 'ecl-transfer-drop.png')"/></td>
                        <td class="team-name" [class.current-team]="teamsService.isUserTeam(this.currentUserTeamIds, transfer.value.team_id)">{{transfer.value.team_name}}</td>
                        <td class="player-name" [class.current-team]="teamsService.isUserTeam(this.currentUserTeamIds, transfer.value.team_id)">{{transfer.value.player_account_activision}}</td>
                        <td class="action-type">{{transfer.value.action_type}}</td>
                    </tr>
                }
            </tbody>
        </table>
      }
    </div>
  </div>
}
@else {
  <div class="no-data">{{ 'transfers.no_transfer' | translate }}</div>
}
